import { BootController } from "../../boot-control";
import { Injectable, ApplicationRef, NgZone } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Observable, Subscription, timer, of, empty } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import * as moment from "moment";
import { IdleTimeoutService } from "./idleTimeout.service";
import { TokenStorageService } from "./token-storage.service";
import { ConfirmationDialogComponent } from "../modules/shared/confirmation-dialog/confirmation-dialog.component";
import { environment } from "../../environments/environment";
import { User } from "../model/user";
import { NotifierService } from "angular-notifier";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ErrorService } from "./error.service";
import { MatDialog } from "@angular/material/dialog";
import { throwError } from "rxjs/internal/observable/throwError";
declare var $: any;
declare function zE(id, value);
declare function zE(id, value, callback);
import * as jwt_decode from "jwt-decode";
import { UtilService } from "./util.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private readonly notifier: NotifierService;
  idleState = "Not started.";
  timedOut = false;
  public _counter: number = 0;
  @BlockUI() blockUI: NgBlockUI;
  public _status: string = "Initialized.";
  private _timer: Observable<number>;
  private _timerSubscription: Subscription;
  private _idleTimerSubscription: Subscription;

  private asgAdminUrl = environment.asgAdminUrl;
  private asgSecurityUrl = environment.asgSecurityUrl;

  public isIdlePopup: boolean = false;
  static count = 0;
  private redirectURL;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private http: HttpClient,
    private idle: Idle,
    private utilService: UtilService,
    private keepalive: Keepalive,
    private changeRef: ApplicationRef,
    private idleTimeoutSvc: IdleTimeoutService,
    private token: TokenStorageService,
    private errSer: ErrorService,
    private ngZone: NgZone,
    private notifierService: NotifierService
  ) {
    if (this.router.url !== "/login") {
      this.notifier = notifierService;
      idle.setIdle(600);
      // idle.setIdle(10);
      /**
       * sets a timeout period of 5 seconds. after 10 seconds of inactivity,
       * the user will be considered timed out.
       */
      idle.setTimeout(5);
      /**
       * sets the default interrupts, in this case, things like clicks,
       * scrolls, touches to the document
       */
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.idleState = "No longer idle.";
      });
      idle.onTimeout.subscribe(() => {});
      idle.onIdleStart.subscribe(() => {
        this.idleState = "You've gone idle!";
      });
      idle.onTimeoutWarning.subscribe((countdown) => {
        this.idleState = "You will time out in " + countdown + " seconds!";
        // console.warn(this.idleState, new Date().toLocaleTimeString())
        if (
          countdown == 1 &&
          !this.isIdlePopup &&
          LoginService.count <= 0 &&
          this.router.url !== "/login" && this.router.url !== "/logout" && this.router.url!=='/reset-password'
        ) {
          this.signoutConfirmationPopUp();
        } else if (this.router.url !== "/login") {
          // console.log(LoginService.count, countdown, this.isIdlePopup)
          this.dialog.closeAll();
        }
      });

      // sets the ping interval to 15 seconds
      keepalive.interval(15);

      this.reset();
    }
  }

  setRedirectUrl(redirectURL){
    if (redirectURL && redirectURL != "/logout" && redirectURL != "/login" && redirectURL != "/EULA" && 
			redirectURL != "/forget-password" && redirectURL != "/reset-password" && redirectURL != "/mfa" && redirectURL != "error/saml") {
			this.redirectURL = redirectURL;
		} else {
			this.redirectURL = "";
		}
  }

  getRedirectUrl(){
    return this.redirectURL;
  }

  singleSignOnEnabled() {
		let queryParams = new HttpParams();
		localStorage.setItem('hostname', window.location.origin);
		let hostname = localStorage.getItem('hostname');
    //for local testing pointing to dev env.
    if(window.location && window.location.host && window.location.host=='localhost.acordsolutions.net'){
      hostname = 'https://dev-transcriber-svc.acordsolutions.net';
    }
		queryParams = queryParams.append("domainName", hostname.split('//')[1]);
		return this.http.get(hostname + '/transcriber-sso/public/v1/sso/enabled', { params: queryParams, observe: 'response' });
	}

  logoutSSOUser() {
		this.logout().then(data => {
			this.logoutSSOUserAndRedirect();
		}, error => {
		});
	}

	logoutSSOUserAndRedirect() {
		this.token.signOut();
		this.setRedirectUrl(null);
		this.router.navigateByUrl('/logout', { state: { userType: 'Sso' }, replaceUrl: true });
		localStorage.setItem('userType', 'Sso')
	}

  public getAccessList(){
    let url  = environment.mappingToolAPIUrl + '/v1/clients/sbac';
    return this.http.get(url, { observe: 'response' });
  }

  async navigateToHomePage(){
    
    let authorizationDecoded = jwt_decode(localStorage.getItem('AuthorizationD'));
    let user;
		if (localStorage.getItem('ssoData') && JSON.parse(localStorage.getItem('ssoData')).sso_enabled === "true") {
			user = authorizationDecoded.userPayload;
			localStorage.setItem('loggedInUser', JSON.stringify(user));
		}else{
      user = JSON.parse(localStorage.getItem("loggedInUser"));
    } 
		if (!user) {
			user = authorizationDecoded.userPayload;
			localStorage.setItem('loggedInUser', JSON.stringify(user));
		}

    try{
      this.utilService.storeConfig();
    }catch(e){
      console.log('Error in loading store config');
    }
    let accessControl = null;
    try{
      let data = await this.getAccessList().toPromise();
      if(data && data.body){
        accessControl=data.body;
        sessionStorage.setItem('accordAccessControl', JSON.stringify(data.body));
      }
    }catch(e){
      console.log('Error in loading accordAccessControl');
    }
    
    let redirectUrl = this.getRedirectUrl();
    if(redirectUrl && redirectUrl.indexOf('/home/extraction-viewer')==0){
      return this.router.navigate([redirectUrl]);
    }else{
      if(redirectUrl){
        return this.router.navigate([redirectUrl]);
      }else{
        return this.router.navigate(['/home/dashboard']);
      }  
    }
  }
  signoutConfirmationPopUp() {
    // console.log(++LoginService.count, this.isIdlePopup, new Date().toLocaleTimeString())
    this.isIdlePopup = true;
    ++LoginService.count;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
      data: "Your session is going to expire. Do you need more time?",
    });

    dialogRef.afterClosed().subscribe((result) => {
      LoginService.count = 0;
      this.isIdlePopup = false;
      if (result) {
        this.reset();
      } else {
        this.idleState = "Timed out!";
        this.timedOut = true;
        // console.log(this.idleState, new Date().toLocaleTimeString())
        let authDecoded = jwt_decode(localStorage.getItem('AuthorizationD'));
        const userType = authDecoded.userPayload.userType;
        if (userType && userType.toLowerCase()== 'sso') {
          this.logoutSSOUser();
        } else {
            this.logout().then(
              (data) => {
                localStorage.removeItem("AuthorizationD");
                localStorage.removeItem("JSESSIONID");
                localStorage.removeItem("token");
                localStorage.removeItem("expires_at");
                localStorage.removeItem("selectedTile");
                localStorage.removeItem("widgets");
                localStorage.removeItem("loggedInUser");
                localStorage.removeItem("userId");
                localStorage.removeItem("orgConfig");
                this.token.signOut();

                this.dialog.closeAll();
                this.setRedirectUrl(null);
                this.router.navigate(['/login'], { replaceUrl: true });
              },
              (error) => {}
            );
          }
        }
    });
  }

  login(email: string, password: string) {}

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }

  loginNew(email: string, password: string) {}

  logout() {
    localStorage.removeItem("loggedInUser");
    let url = this.asgSecurityUrl + "/asg/user/logout";

    return this.http
      .get(this.asgSecurityUrl + "/asg/user/logout")
      .toPromise()
      .then((response: any) => response as any)
      .catch((err: any) => err as any);
  }

  public isLoggedIn() {
    if (moment().isBefore(this.getExpiration())) {
      this._idleTimerSubscription =
        this.idleTimeoutSvc.timeoutExpired.subscribe((res) => {
          // console.log('timeout');
        });
    }
    return moment().isBefore(this.getExpiration());
  }

  getExpiration() {
    const expiration = localStorage.getItem("expires_at");
    let expiresAt;

    if (!expiration) {
      expiresAt = moment();
    } else {
      expiresAt = JSON.parse(expiration);
    }

    return moment(expiresAt);
  }


  doLogin(credentials) {
    let cred = credentials;
    let options = {
      headers: new HttpHeaders({
        Authorization:
          "Basic " + btoa(credentials.email + ":" + credentials.password),
          observe: 'response' as 'body'
      }),
      observe: 'response' as 'body'
    };

    let url = this.asgSecurityUrl + "/asg/user/signon";

    return this.http.post(url, credentials, options).pipe(
      map((data) => {
        this.idle.watch();
        return data;
      }),
      catchError((error) => {
        // console.log('error : ', error);
        // if (error && error.error && error.error.message) {

        // }
        this.errSer.stopLoaderAndShowError(error);
        if (
          error == "Your password is expired, please update a new password."
        ) {
          this.router.navigate(["/home/user/changePassword"]);
        }
        return empty();
      })
    );
  }

  forgotPassword(email): Observable<any> {
    let options = {
      headers: new HttpHeaders({
      }),
    };

    let url =
      this.asgAdminUrl + "/public/v1/api/user/" + email + "/forgetPassword";
    return this.http.put<any>(url, {}, options);
    // .pipe(
    // 	map((data: User) => {
    // 		return data;
    // 	}),
    // 	catchError((error) => {
    // 		this.errSer.stopLoaderAndShowError(error);
    // 		return empty()
    // 	})
    // )
  }

  resetPassword(reqData): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        observe: "response",
      }),
    };

    let url =
      this.asgAdminUrl +
      "/public/v1/api/user/" +
      reqData.changePasswordLinkKey +
      "/resetPassword";
    return this.http.put<any>(url, reqData, options);
    // .pipe(
    //   catchError((err) => {
    //     console.log('error caught in service')
    //     console.error(err);

    //     //Handle the error here

    //     return throwError(err);    //Rethrow it back to component
    //   })
    // )
    // .toPromise()
    // .then((response: any) => response as any)
    // .catch();
  }

  public validateResetLink(uuid): Observable<any> {
    let url = this.asgAdminUrl + "/v1/changePasswordLinks/" + uuid;
    return this.http.get(url);
  }

  changePassword(id, user) {
    let url = this.asgAdminUrl + "/asg/admin/users/" + id + "/change-password";
    return this.http.put(url, user).pipe(
      map((data: User) => {
        return data;
      }),
      catchError((error) => {
        this.errSer.stopLoaderAndShowError(error);
        return empty();
      })
    );
  }

  public getOutputFile(
    formData,
    file: string,
    userData: any,
    isCustomForm: boolean,
    docType: any,
    senderCode,
    receiverCode
  ) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (docType == "pdf") {
      var endpoint =
        "https://dev-svc-iforms.acordsolutions.net/esbservice/iforms/extraction?inpFormat=" +
        "PDF" +
        "&outFormat=ELABEL&responseType=" +
        "XML";
      if (formData.form) {
        endpoint =
          endpoint +
          "&formName=" +
          formData.form +
          "&formSource=" +
          formData.formSource;
      }
      endpoint =
        endpoint +
        "&userId=" +
        userData.email +
        "&orgId=" +
        userData.orgId +
        "&customForm=true";
    }

    if (docType == "excel") {
      var endpoint =
        "https://dev-svc-iforms.acordsolutions.net/esbservice/iforms/extraction?formId=" +
        formData.formId +
        "&responseType=" +
        "CSV";
    }
    if (senderCode) {
      endpoint = endpoint + "&senderCode=" + senderCode;
    }
    if (receiverCode) {
      endpoint = endpoint + "&receiverCode=" + receiverCode;
    }
    return this.http
      .post(endpoint, file, requestOptions)
      .toPromise()
      .then((response: any) => response as any)
      .catch((err: any) => err as any);
  }

  public excelExtraction(file: string, formId): Observable<any> {
    const requestOptions: Object = {
      responseType: "text",
      headers: [
        {
          name: "Authorization",
          value: localStorage.getItem("AuthorizationD"),
        },
        { name: "JSESSIONID", value: localStorage.getItem("JSESSIONID") },
        { name: "Cache-Control", value: "no-cache, no-store, must-revalidate" },
        { name: "Pragma", value: "no-cache" },
        { name: "X-Content-Type-Options", value: "nosniff" },
      ],
    };
    return this.http.post(
      environment.mappingToolAPIUrl + "/excel?formId=" + formId,
      file,
      requestOptions
    );
  }

  public getDocument() {
    // let url = 'https://asg-iforms-testdata.s3.amazonaws.com/test/OutputXML.xml?AWSAccessKeyId=AKIA2WNXLZRENCOU536N&Signature=H358ICNMpFKeLaHjR1gKeGyr3TA%3D&Expires=1580232187';
    let url = environment.mappingToolAPIUrl + "/iforms/fuse/output";
    return this.http
      .get(url, { responseType: "text" })
      .toPromise()
      .then((response: any) => response as any)
      .catch((err: any) => err as any);
  }

  public updateLocale(userlocale, userId) {
    let url = environment.asgAdminUrl + "/asg/admin/users/locale";
    return this.http
      .post(
        url,
        {
          userId: userId,
          locale: userlocale.userLocale,
          datetime_format: userlocale.userFormat,
        },
        { responseType: "text" }
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getLocales(): Observable<any> {
    let url = environment.asgAdminUrl + "/asg/admin/all/locale";
    return this.http.get(url);
  }

  public getUserLocale() {
    let url = environment.asgAdminUrl + "/asg/admin/users/locale";
    return this.http
      .get(url)
      .toPromise()
      .then((response: any) => response as any)
      .catch((err: any) => err as any);
  }

  // customization of default zendesk webwidget.
  setZendeskView(isloggedIn) {
    zE("webWidget", "reset"); // resetting the zendesk widget .
    zE("webWidget", "show");
    zE("webWidget", "open");
    zE("webWidget", "clear"); // clearing the old field values.
    if (isloggedIn && localStorage.getItem("loggedInUser") != null) {
      let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
      zE("webWidget", "prefill", {
        name: {
          value: loggedInUser.firstName + ' ' + loggedInUser.lastName,
        },
        email: {
          value: jwt_decode(localStorage.getItem('AuthorizationD'))?.userPayload?.email,
        },
      });
    }
    setTimeout(() => {
      if ($("#webWidget").contents().find("head") != undefined) {
        $("#webWidget").contents().find("button:first").css("color", "white");
        $("#webWidget")
          .contents()
          .find("button:launcher")
          .css("display", "none !important");
      }
    }, 1000);
  }
}
